export function removeLeadingZeros(value: string) {
  if (!value) {
    return '';
  }

  const removeZerosUntilNotZeroFoundRegex = /^0+/;
  const result = value.replace(removeZerosUntilNotZeroFoundRegex, '');
  return result || '0';
}
